var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"id":"ticket-history-modal","size":"large","hideSubmitButton":true,"title":_vm.$t('history'),"preloader":_vm.preloader},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('app-table',{attrs:{"id":"ticket-history-table","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }